<div *ngIf="!closed" class="lum-alert__wrapper" [ngClass]="classes">
  <div class="lum-alert__content">
    <div class="flex lum-alert__message">
      <div *ngIf="showIcon" class="lum-alert__icon mr-2">
        <lum-ui-icon
          [icon]="iconAttribute.icon"
          [width]="20"
          [height]="20"
          [color]="iconAttribute.hex"
        ></lum-ui-icon>
      </div>
      <div [innerHTML]="message"></div>
    </div>
    <div
      *ngIf="description"
      [innerHTML]="description"
      class="lum-alert__description mt-2"
    ></div>

    <button *ngIf="showClose" class="lum-alert__close" (click)="onClose()">
      <lum-ui-icon
        icon="close"
        [width]="16"
        [height]="16"
        color="#36363A"
      ></lum-ui-icon>
    </button>
  </div>
</div>
